import {
  ApplicationConfig, PLATFORM_ID, isDevMode,
  //provideExperimentalZonelessChangeDetection,
  provideZoneChangeDetection
} from '@angular/core'
import {
  provideRouter,
  //withDebugTracing,
  withEnabledBlockingInitialNavigation,
  withRouterConfig,
  withViewTransitions,
  withComponentInputBinding,
  //withDebugTracing
} from '@angular/router'
import { appRoutes } from './app.routes'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { importProvidersFrom } from '@angular/core'
import { provideClientHydration, withHttpTransferCacheOptions } from '@angular/platform-browser'
import { provideServiceWorker } from '@angular/service-worker'
import { provideHttpClient, withFetch } from '@angular/common/http'

import { NgCircleProgressModule } from 'ng-circle-progress'

import { BsModalService } from 'ngx-bootstrap/modal'
import { provideFirebaseProviders } from './config/firebase.config'
import { provideSentryProviders } from './config/sentry.config'

export const appConfig: ApplicationConfig = {
  providers: [
    //provideExperimentalZonelessChangeDetection(),
    provideZoneChangeDetection({ eventCoalescing: true, ignoreChangesOutsideZone: false }),
    provideClientHydration(withHttpTransferCacheOptions({includePostRequests: true})),
    provideRouter(
      appRoutes,
      //withDebugTracing(),
      withEnabledBlockingInitialNavigation(),
      withRouterConfig({ onSameUrlNavigation: 'reload' }),
      withComponentInputBinding(),
      withViewTransitions()
    ),
    provideAnimationsAsync(),
    provideHttpClient(withFetch()),
    importProvidersFrom(NgCircleProgressModule.forRoot()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerImmediately'//'registerWhenStable:3000'
    }),
    provideFirebaseProviders(),
    provideSentryProviders(PLATFORM_ID),
    BsModalService
  ]
}
